
import { mapState } from 'vuex'

export default {
  name: 'MinimalLayout',
  computed: mapState(['loadingMessageOverlay']),
  beforeMount() {
    window.onresize = () => this.$store.commit('setWindowWidth')
  },
}
